import { render, staticRenderFns } from "./ArticlePriceRuleForm.vue?vue&type=template&id=da4b9416&"
import script from "./ArticlePriceRuleForm.vue?vue&type=script&lang=js&"
export * from "./ArticlePriceRuleForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports